
import i18n from 'i18next'; 
import { initReactI18next } from 'react-i18next'; 
import LanguageDetector from 'i18next-browser-languagedetector';

import enCommon from './components/locales/common/en.json';
import esCommon from './components/locales/common/es.json';
import frCommon from './components/locales/common/fr.json';
import deCommon from './components/locales/common/de.json';
import ptCommon from './components/locales/common/pt.json';
import itCommon from './components/locales/common/it.json';
import hiCommon from './components/locales/common/hi.json';
import zhCommon from './components/locales/common/zh.json';
import arCommon from './components/locales/common/ar.json';

// HomePage
import enHomePage from './components/HomePage/locales/en.json'; 
import esHomePage from './components/HomePage/locales/es.json'; 
import frHomePage from './components/HomePage/locales/fr.json'; 
import zhHomePage from './components/HomePage/locales/zh.json'; 
import arHomePage from './components/HomePage/locales/ar.json'; 
import hiHomePage from './components/HomePage/locales/hi.json'; 
import itHomePage from './components/HomePage/locales/it.json'; 
import ptHomePage from './components/HomePage/locales/pt.json'; 
import deHomePage from './components/HomePage/locales/de.json'; 

// SecurityNotice
import enSecurityNotice from './components/Notices/locales/SecurityNotice/en.json'; 
import esSecurityNotice from './components/Notices/locales/SecurityNotice/es.json'; 
import frSecurityNotice from './components/Notices/locales/SecurityNotice/fr.json'; 
import zhSecurityNotice from './components/Notices/locales/SecurityNotice/zh.json'; 
import arSecurityNotice from './components/Notices/locales/SecurityNotice/ar.json'; 
import hiSecurityNotice from './components/Notices/locales/SecurityNotice/hi.json'; 
import itSecurityNotice from './components/Notices/locales/SecurityNotice/it.json'; 
import ptSecurityNotice from './components/Notices/locales/SecurityNotice/pt.json'; 
import deSecurityNotice from './components/Notices/locales/SecurityNotice/de.json'; 

import enLogin from './components/Login/locales/en.json';
import esLogin from './components/Login/locales/es.json';
import frLogin from './components/Login/locales/fr.json';
import deLogin from './components/Login/locales/de.json';
import ptLogin from './components/Login/locales/pt.json';
import itLogin from './components/Login/locales/it.json';
import hiLogin from './components/Login/locales/hi.json';
import zhLogin from './components/Login/locales/zh.json';
import arLogin from './components/Login/locales/ar.json';


// Register
import enRegister from './components/Register/locales/en.json'; 
import esRegister from './components/Register/locales/es.json'; 
import frRegister from './components/Register/locales/fr.json'; 
import zhRegister from './components/Register/locales/zh.json'; 
import arRegister from './components/Register/locales/ar.json'; 
import hiRegister from './components/Register/locales/hi.json'; 
import itRegister from './components/Register/locales/it.json'; 
import ptRegister from './components/Register/locales/pt.json'; 
import deRegister from './components/Register/locales/de.json'; 

// Dashboard
import enDashboard from './components/Dashboard/locales/en.json'; 
import esDashboard from './components/Dashboard/locales/es.json'; 
import frDashboard from './components/Dashboard/locales/fr.json'; 
import zhDashboard from './components/Dashboard/locales/zh.json'; 
import arDashboard from './components/Dashboard/locales/ar.json'; 
import hiDashboard from './components/Dashboard/locales/hi.json'; 
import itDashboard from './components/Dashboard/locales/it.json'; 
import ptDashboard from './components/Dashboard/locales/pt.json'; 
import deDashboard from './components/Dashboard/locales/de.json'; 

// Transactions
import enTransactions from './components/Transactions/locales/en.json'; 
import esTransactions from './components/Transactions/locales/es.json'; 
import frTransactions from './components/Transactions/locales/fr.json'; 
import zhTransactions from './components/Transactions/locales/zh.json'; 
import arTransactions from './components/Transactions/locales/ar.json'; 
import hiTransactions from './components/Transactions/locales/hi.json'; 
import itTransactions from './components/Transactions/locales/it.json'; 
import ptTransactions from './components/Transactions/locales/pt.json'; 
import deTransactions from './components/Transactions/locales/de.json'; 

// Receive
import enReceive from './components/Receive/locales/en.json'; 
import esReceive from './components/Receive/locales/es.json'; 
import frReceive from './components/Receive/locales/fr.json'; 
import zhReceive from './components/Receive/locales/zh.json'; 
import arReceive from './components/Receive/locales/ar.json'; 
import hiReceive from './components/Receive/locales/hi.json'; 
import itReceive from './components/Receive/locales/it.json'; 
import ptReceive from './components/Receive/locales/pt.json'; 
import deReceive from './components/Receive/locales/de.json'; 

// Smartnodes
import enSmartnodes from './components/Smartnodes/locales/en.json'; 
import esSmartnodes from './components/Smartnodes/locales/es.json'; 
import frSmartnodes from './components/Smartnodes/locales/fr.json'; 
import zhSmartnodes from './components/Smartnodes/locales/zh.json'; 
import arSmartnodes from './components/Smartnodes/locales/ar.json'; 
import hiSmartnodes from './components/Smartnodes/locales/hi.json'; 
import itSmartnodes from './components/Smartnodes/locales/it.json'; 
import ptSmartnodes from './components/Smartnodes/locales/pt.json'; 
import deSmartnodes from './components/Smartnodes/locales/de.json';

// Navbar
import enNavbar from './components/Navbar/locales/en.json';
import esNavbar from './components/Navbar/locales/es.json';
import frNavbar from './components/Navbar/locales/fr.json';
import zhNavbar from './components/Navbar/locales/zh.json';
import arNavbar from './components/Navbar/locales/ar.json';
import hiNavbar from './components/Navbar/locales/hi.json';
import itNavbar from './components/Navbar/locales/it.json';
import ptNavbar from './components/Navbar/locales/pt.json';
import deNavbar from './components/Navbar/locales/de.json';

// Send
import enSend from './components/Send/locales/en.json';
import esSend from './components/Send/locales/es.json';
import frSend from './components/Send/locales/fr.json';
import zhSend from './components/Send/locales/zh.json';
import arSend from './components/Send/locales/ar.json';
import hiSend from './components/Send/locales/hi.json';
import itSend from './components/Send/locales/it.json';
import ptSend from './components/Send/locales/pt.json';
import deSend from './components/Send/locales/de.json';

// SwapFunds
import enSwapFunds from './components/SwapFunds/locales/en.json';
import esSwapFunds from './components/SwapFunds/locales/es.json';
import frSwapFunds from './components/SwapFunds/locales/fr.json';
import zhSwapFunds from './components/SwapFunds/locales/zh.json';
import arSwapFunds from './components/SwapFunds/locales/ar.json';
import hiSwapFunds from './components/SwapFunds/locales/hi.json';
import itSwapFunds from './components/SwapFunds/locales/it.json';
import ptSwapFunds from './components/SwapFunds/locales/pt.json';
import deSwapFunds from './components/SwapFunds/locales/de.json';

import enFunds from './components/FundsDistribution/locales/en.json';
import esFunds from './components/FundsDistribution/locales/es.json';
import frFunds from './components/FundsDistribution/locales/fr.json';
import deFunds from './components/FundsDistribution/locales/de.json';
import ptFunds from './components/FundsDistribution/locales/pt.json';
import itFunds from './components/FundsDistribution/locales/it.json';
import hiFunds from './components/FundsDistribution/locales/hi.json';
import zhFunds from './components/FundsDistribution/locales/zh.json';
import arFunds from './components/FundsDistribution/locales/ar.json';


// Baccarat
import enBaccarat from './components/Games/Baccarat/locales/en.json';
import esBaccarat from './components/Games/Baccarat/locales/es.json';
import frBaccarat from './components/Games/Baccarat/locales/fr.json';
import ptBaccarat from './components/Games/Baccarat/locales/pt.json';
import deBaccarat from './components/Games/Baccarat/locales/de.json';
import itBaccarat from './components/Games/Baccarat/locales/it.json';
import hiBaccarat from './components/Games/Baccarat/locales/hi.json';
import zhBaccarat from './components/Games/Baccarat/locales/zh.json';
import arBaccarat from './components/Games/Baccarat/locales/ar.json';

// MenelDie
import enMenelDie from './components/Games/MenelDie/locales/en.json';
import esMenelDie from './components/Games/MenelDie/locales/es.json';
import frMenelDie from './components/Games/MenelDie/locales/fr.json';
import ptMenelDie from './components/Games/MenelDie/locales/pt.json';
import deMenelDie from './components/Games/MenelDie/locales/de.json';
import itMenelDie from './components/Games/MenelDie/locales/it.json';
import hiMenelDie from './components/Games/MenelDie/locales/hi.json';
import zhMenelDie from './components/Games/MenelDie/locales/zh.json';
import arMenelDie from './components/Games/MenelDie/locales/ar.json';

//  MENEL DUEL DICE 
import enMenelDuelDice from './components/Games/MenelDuelDice/locales/en.json';
import esMenelDuelDice from './components/Games/MenelDuelDice/locales/es.json';
import frMenelDuelDice from './components/Games/MenelDuelDice/locales/fr.json';
import ptMenelDuelDice from './components/Games/MenelDuelDice/locales/pt.json';
import deMenelDuelDice from './components/Games/MenelDuelDice/locales/de.json';
import itMenelDuelDice from './components/Games/MenelDuelDice/locales/it.json';
import hiMenelDuelDice from './components/Games/MenelDuelDice/locales/hi.json';
import zhMenelDuelDice from './components/Games/MenelDuelDice/locales/zh.json';
import arMenelDuelDice from './components/Games/MenelDuelDice/locales/ar.json';

// BullfighterOrBull
import enBullfighter from './components/Games/BullfighterOrBull/locales/en.json';
import esBullfighter from './components/Games/BullfighterOrBull/locales/es.json';
import frBullfighter from './components/Games/BullfighterOrBull/locales/fr.json';
import deBullfighter from './components/Games/BullfighterOrBull/locales/de.json';
import ptBullfighter from './components/Games/BullfighterOrBull/locales/pt.json';
import itBullfighter from './components/Games/BullfighterOrBull/locales/it.json';
import hiBullfighter from './components/Games/BullfighterOrBull/locales/hi.json';
import zhBullfighter from './components/Games/BullfighterOrBull/locales/zh.json';
import arBullfighter from './components/Games/BullfighterOrBull/locales/ar.json';

// BlackJack
import enBlackJack from './components/Games/BlackJack/locales/en.json';
import esBlackJack from './components/Games/BlackJack/locales/es.json';
import frBlackJack from './components/Games/BlackJack/locales/fr.json';
import deBlackJack from './components/Games/BlackJack/locales/de.json';
import ptBlackJack from './components/Games/BlackJack/locales/pt.json';
import itBlackJack from './components/Games/BlackJack/locales/it.json';
import hiBlackJack from './components/Games/BlackJack/locales/hi.json';
import zhBlackJack from './components/Games/BlackJack/locales/zh.json';
import arBlackJack from './components/Games/BlackJack/locales/ar.json';

// FiveCardDraw
import enFiveCardDraw from './components/Games/FiveCardDraw/locales/en.json';
import esFiveCardDraw from './components/Games/FiveCardDraw/locales/es.json';
import frFiveCardDraw from './components/Games/FiveCardDraw/locales/fr.json';
import deFiveCardDraw from './components/Games/FiveCardDraw/locales/de.json';
import ptFiveCardDraw from './components/Games/FiveCardDraw/locales/pt.json';
import itFiveCardDraw from './components/Games/FiveCardDraw/locales/it.json';
import hiFiveCardDraw from './components/Games/FiveCardDraw/locales/hi.json';
import zhFiveCardDraw from './components/Games/FiveCardDraw/locales/zh.json';
import arFiveCardDraw from './components/Games/FiveCardDraw/locales/ar.json';

// WarGame
import enWar from './components/Games/WarGame/locales/en.json';
import esWar from './components/Games/WarGame/locales/es.json';
import frWar from './components/Games/WarGame/locales/fr.json';
import deWar from './components/Games/WarGame/locales/de.json';
import ptWar from './components/Games/WarGame/locales/pt.json';
import itWar from './components/Games/WarGame/locales/it.json';
import hiWar from './components/Games/WarGame/locales/hi.json';
import zhWar from './components/Games/WarGame/locales/zh.json';
import arWar from './components/Games/WarGame/locales/ar.json';

// RedDog
import enRedDog from './components/Games/RedDog/locales/en.json';
import esRedDog from './components/Games/RedDog/locales/es.json';
import frRedDog from './components/Games/RedDog/locales/fr.json';
import deRedDog from './components/Games/RedDog/locales/de.json';
import ptRedDog from './components/Games/RedDog/locales/pt.json';
import itRedDog from './components/Games/RedDog/locales/it.json';
import hiRedDog from './components/Games/RedDog/locales/hi.json';
import zhRedDog from './components/Games/RedDog/locales/zh.json';
import arRedDog from './components/Games/RedDog/locales/ar.json';

// ChinesePoker
import enChinesePoker from './components/Games/ChinesePoker/locales/en.json';
import esChinesePoker from './components/Games/ChinesePoker/locales/es.json';
import frChinesePoker from './components/Games/ChinesePoker/locales/fr.json';
import deChinesePoker from './components/Games/ChinesePoker/locales/de.json';
import ptChinesePoker from './components/Games/ChinesePoker/locales/pt.json';
import itChinesePoker from './components/Games/ChinesePoker/locales/it.json';
import hiChinesePoker from './components/Games/ChinesePoker/locales/hi.json';
import zhChinesePoker from './components/Games/ChinesePoker/locales/zh.json';
import arChinesePoker from './components/Games/ChinesePoker/locales/ar.json';

// Caribbean Stud
import enCaribbean from './components/Games/CaribbeanStudPoker/locales/en.json';
import esCaribbean from './components/Games/CaribbeanStudPoker/locales/es.json';
import frCaribbean from './components/Games/CaribbeanStudPoker/locales/fr.json';
import deCaribbean from './components/Games/CaribbeanStudPoker/locales/de.json';
import ptCaribbean from './components/Games/CaribbeanStudPoker/locales/pt.json';
import itCaribbean from './components/Games/CaribbeanStudPoker/locales/it.json';
import hiCaribbean from './components/Games/CaribbeanStudPoker/locales/hi.json';
import zhCaribbean from './components/Games/CaribbeanStudPoker/locales/zh.json';
import arCaribbean from './components/Games/CaribbeanStudPoker/locales/ar.json';

// CardPoker
import enCardPoker from './components/Games/CardPoker/locales/en.json';
import esCardPoker from './components/Games/CardPoker/locales/es.json';
import frCardPoker from './components/Games/CardPoker/locales/fr.json';
import deCardPoker from './components/Games/CardPoker/locales/de.json';
import ptCardPoker from './components/Games/CardPoker/locales/pt.json';
import itCardPoker from './components/Games/CardPoker/locales/it.json';
import hiCardPoker from './components/Games/CardPoker/locales/hi.json';
import zhCardPoker from './components/Games/CardPoker/locales/zh.json';
import arCardPoker from './components/Games/CardPoker/locales/ar.json';

// PaiGowPoker
import enPaiGow from './components/Games/PaiGowPoker/locales/en.json';
import esPaiGow from './components/Games/PaiGowPoker/locales/es.json';
import frPaiGow from './components/Games/PaiGowPoker/locales/fr.json';
import dePaiGow from './components/Games/PaiGowPoker/locales/de.json';
import ptPaiGow from './components/Games/PaiGowPoker/locales/pt.json';
import itPaiGow from './components/Games/PaiGowPoker/locales/it.json';
import hiPaiGow from './components/Games/PaiGowPoker/locales/hi.json';
import zhPaiGow from './components/Games/PaiGowPoker/locales/zh.json';
import arPaiGow from './components/Games/PaiGowPoker/locales/ar.json';

// Numeric Slot
import enNumericSlot from './components/Games/NumericSlotMachine/locales/en.json';
import esNumericSlot from './components/Games/NumericSlotMachine/locales/es.json';
import frNumericSlot from './components/Games/NumericSlotMachine/locales/fr.json';
import deNumericSlot from './components/Games/NumericSlotMachine/locales/de.json';
import ptNumericSlot from './components/Games/NumericSlotMachine/locales/pt.json';
import itNumericSlot from './components/Games/NumericSlotMachine/locales/it.json';
import hiNumericSlot from './components/Games/NumericSlotMachine/locales/hi.json';
import zhNumericSlot from './components/Games/NumericSlotMachine/locales/zh.json';
import arNumericSlot from './components/Games/NumericSlotMachine/locales/ar.json';


i18n 
  .use(LanguageDetector) 
  .use(initReactI18next) 
  .init({ 
    resources: { 
      en: { translation: { ...enCommon, ...enHomePage, ...enSecurityNotice, ...enLogin, ...enRegister, ...enDashboard, ...enTransactions, ...enReceive, ...enSmartnodes, ...enNavbar, ...enSend, ...enSwapFunds, ...enFunds, ...enBaccarat, ...enMenelDie, ...enBullfighter, ...enBlackJack, ...enFiveCardDraw, ...enMenelDuelDice, ...enWar, ...enRedDog, ...enChinesePoker, ...enCaribbean, ...enCardPoker, ...enPaiGow, ...enNumericSlot } }, 
      es: { translation: { ...esCommon, ...esHomePage, ...esSecurityNotice, ...esLogin, ...esRegister, ...esDashboard, ...esTransactions, ...esReceive, ...esSmartnodes, ...esNavbar, ...esSend, ...esSwapFunds, ...esFunds, ...esBaccarat, ...esMenelDie, ...esBullfighter, ...esBlackJack, ...esFiveCardDraw, ...esMenelDuelDice, ...esWar, ...esRedDog, ...esChinesePoker, ...esCaribbean, ...esCardPoker, ...esPaiGow, ...esNumericSlot } }, 
      fr: { translation: { ...frCommon, ...frHomePage, ...frSecurityNotice, ...frLogin, ...frRegister, ...frDashboard, ...frTransactions, ...frReceive, ...frSmartnodes, ...frNavbar, ...frSend, ...frSwapFunds, ...frFunds, ...frBaccarat, ...frMenelDie, ...frBullfighter, ...frBlackJack, ...frFiveCardDraw, ...frMenelDuelDice, ...frWar, ...frRedDog, ...frChinesePoker, ...frCaribbean, ...frCardPoker, ...frPaiGow, ...frNumericSlot } }, 
      zh: { translation: { ...zhCommon, ...zhHomePage, ...zhSecurityNotice, ...zhLogin, ...zhRegister, ...zhDashboard, ...zhTransactions, ...zhReceive, ...zhSmartnodes, ...zhNavbar, ...zhSend, ...zhSwapFunds, ...zhFunds, ...zhBaccarat, ...zhMenelDie, ...zhBullfighter, ...zhBlackJack, ...zhFiveCardDraw, ...zhMenelDuelDice, ...zhWar, ...zhRedDog, ...zhChinesePoker, ...zhCaribbean, ...zhCardPoker, ...zhPaiGow, ...zhNumericSlot } }, 
      ar: { translation: { ...arCommon, ...arHomePage, ...arSecurityNotice, ...arLogin, ...arRegister, ...arDashboard, ...arTransactions, ...arReceive, ...arSmartnodes, ...arNavbar, ...arSend, ...arSwapFunds, ...arFunds, ...arBaccarat, ...arMenelDie, ...arBullfighter, ...arBlackJack, ...arFiveCardDraw, ...arMenelDuelDice, ...arWar, ...arRedDog, ...arChinesePoker, ...arCaribbean, ...arCardPoker, ...arPaiGow, ...arNumericSlot } }, 
      hi: { translation: { ...hiCommon, ...hiHomePage, ...hiSecurityNotice, ...hiLogin, ...hiRegister, ...hiDashboard, ...hiTransactions, ...hiReceive, ...hiSmartnodes, ...hiNavbar, ...hiSend, ...hiSwapFunds, ...hiFunds, ...hiBaccarat, ...hiMenelDie, ...hiBullfighter, ...hiBlackJack, ...hiFiveCardDraw, ...hiMenelDuelDice, ...hiWar, ...hiRedDog, ...hiChinesePoker, ...hiCaribbean, ...hiCardPoker, ...hiPaiGow, ...hiNumericSlot } }, 
      it: { translation: { ...itCommon, ...itHomePage, ...itSecurityNotice, ...itLogin, ...itRegister, ...itDashboard, ...itTransactions, ...itReceive, ...itSmartnodes, ...itNavbar, ...itSend, ...itSwapFunds, ...itFunds, ...itBaccarat, ...itMenelDie, ...itBullfighter, ...itBlackJack, ...itFiveCardDraw, ...itMenelDuelDice, ...itWar, ...itRedDog, ...itChinesePoker, ...itCaribbean, ...itCardPoker, ...itPaiGow, ...itNumericSlot } }, 
      pt: { translation: { ...ptCommon, ...ptHomePage, ...ptSecurityNotice, ...ptLogin, ...ptRegister, ...ptDashboard, ...ptTransactions, ...ptReceive, ...ptSmartnodes, ...ptNavbar, ...ptSend, ...ptSwapFunds, ...ptFunds, ...ptBaccarat, ...ptMenelDie, ...ptBullfighter, ...ptBlackJack, ...ptFiveCardDraw, ...ptMenelDuelDice, ...ptWar, ...ptRedDog, ...ptChinesePoker, ...ptCaribbean, ...ptCardPoker, ...ptPaiGow, ...ptNumericSlot } }, 
      de: { translation: { ...deCommon, ...deHomePage, ...deSecurityNotice, ...deLogin, ...deRegister, ...deDashboard, ...deTransactions, ...deReceive, ...deSmartnodes, ...deNavbar, ...deSend, ...deSwapFunds, ...deFunds, ...deBaccarat, ...deMenelDie, ...deBullfighter, ...deBlackJack, ...deFiveCardDraw, ...deMenelDuelDice, ...deWar, ...deRedDog, ...deChinesePoker, ...deCaribbean, ...deCardPoker, ...dePaiGow, ...deNumericSlot } }
    }, 
    fallbackLng: 'en', 
    interpolation: { escapeValue: false } 
  });

export default i18n;